import { useEffect } from 'react';
import { Map } from '../abstract/map';
import { Filters } from './filters';
import { StatusBar } from './status-bar';
import { Sidebar } from './sidebar';
import { Sheet } from './sheet';
import { Spinner } from './spinner';

import { useSearch } from '../../hooks/search';
import { useViewport } from '../../hooks/viewport';
import { useFilters } from '../../hooks/filters';
import { usePropertiesInViewport } from '../../hooks/properties-in-viewport';
import { useMarkers } from '../../hooks/markers';

/*
TODO:
- show properties count on filters popup button
- add layout_scroll_blocked on popup open
- support ESC key to close filters popup
- dropdowns with options rendered outside
- favorite feature
- land and building size custom labels | buildingSizePlacehoder | landSizePlacehoder
- fullscreen mode
- rework setFilters and updateQuery to useContext. maybe config too?
- add appear/disappear animations for map-search__highlights-content
- refactor all button classes - remove them and apply custom styles
- look for better way to handle photos swipe
- support different colors for tags
- distinct exact and approximate location
- examine https://maplibre.org/maplibre-gl-js/docs/ | https://openfreemap.org/quick_start/
*/
export function MapSearch({
  config,
}) {
  useEffect(() => console.log(config), []);

  let {
    map,
    zoom,
    viewport,
    bounds,
    fitBounds,
    onMapInit,
    onViewportEvent,
  } = useViewport();

  let filtersContext = useFilters(config);

  let { properties, count, isLoading } = useSearch({
    fitBounds,
    filters: filtersContext.filters,
    isFiltersOpened: filtersContext.isOpened,
    isFiltersInited: filtersContext.isInited,
    urlFormat: config.urlFormat,
  });

  let {
    boundedProperties,
    viewportedProperties,
    highlightedProperties,
    highlightProperties,
  } = usePropertiesInViewport(properties, viewport);

  let markers = useMarkers({ map, properties: boundedProperties, zoom, fitBounds, highlightProperties });

  return (
    <>
      <StatusBar
        openFilters={filtersContext.open}
        isFiltersOpened={filtersContext.isOpened}
        isLoading={isLoading}
        count={count}
        {...filtersContext}
      />

      <Sidebar
        isLoading={isLoading}
        isNothing={!properties.length}
        highlightedProperties={highlightedProperties}
        viewportedProperties={viewportedProperties}
      />

      <Map
        accessToken={config.accessToken}
        bounds={bounds}
        markers={markers}

        isLoading={isLoading}
        isNothing={!properties.length}

        onMapInit={onMapInit}
        onViewportEvent={onViewportEvent}
        openFilters={filtersContext.open}
      />

      <Filters config={config} {...filtersContext} />

      <Spinner isLoading={isLoading} />

      <Sheet
        properties={highlightedProperties}
        setProperties={highlightProperties}
      />
    </>
  );
}
